import styled from 'styled-components'

import {Wrapper as DatePickerWrapper} from '@/src/shared/ui/inputs/date-picker'
import FormPhoneInput from '@/src/shared/ui/inputs/form-phone-input'
import {FormInput, InputUI} from '@/src/shared/ui/inputs/input'

export const Wrapper = styled.div`
  position: relative;

  display: grid;
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;

  row-gap: 15px;
`

export const Phone = styled(FormPhoneInput)`
  display: grid;
  gap: 15px;
  align-items: center;

  grid-template-columns: subgrid;
  grid-template-rows: subgrid;

  grid-column: 1 / 3;

  & > * {
    &:first-child {
      grid-column: 1;
    }

    &:last-child {
      grid-column: 2;
    }
  }

  & ${InputUI.Input} {
    display: flex;

    &:before {
      content: unset;
    }
  }
`

export const Input = styled(FormInput)`
  width: 100%;

  &${InputUI.Wrapper}, &${DatePickerWrapper} {
    display: grid;
    gap: 15px;
    align-items: center;

    grid-template-columns: subgrid;
    grid-template-rows: subgrid;

    grid-column: 1 / 3;

    & > * {
      &:first-child {
        grid-column: 1;
      }

      &:last-child {
        grid-column: 2;
      }
    }
  }
`

export const SFormInput = styled(FormInput)`
  &${InputUI.Wrapper}, &${DatePickerWrapper} {
    display: grid;
    gap: 15px;
    align-items: center;

    grid-template-columns: subgrid;
    grid-template-rows: subgrid;

    grid-column: 1 / 3;

    & > * {
      &:first-child {
        grid-column: 1;
      }

      &:last-child {
        grid-column: 2;
      }
    }
  }
`

export const DatePicker = styled(Input)``
